var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatisticIconActionItems(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M18.5 0C28.7173 0 37 8.28273 37 18.5C37 28.7173 28.7173 37 18.5 37C8.28273 37 0 28.7173 0 18.5C0 8.28273 8.28273 0 18.5 0Z",
    fill: "#4880FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.587821,
    d: "M23.4326 15.2113C24.7949 15.2113 25.8994 16.3158 25.8994 17.6781C25.8992 19.0402 24.7948 20.1449 23.4326 20.1449C22.0706 20.1446 20.967 19.0401 20.9668 17.6781C20.9668 16.316 22.0705 15.2116 23.4326 15.2113ZM16.0332 11.1C17.8495 11.1001 19.3223 12.5727 19.3223 14.389C19.3222 16.2053 17.8495 17.678 16.0332 17.6781C14.2169 17.6781 12.7442 16.2054 12.7441 14.389C12.7441 12.5726 14.2168 11.1 16.0332 11.1Z",
    fill: "#4880FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0191 19.3221C19.9558 19.3221 23.1902 21.2076 23.4312 25.2421C23.4408 25.4027 23.4312 25.9 22.814 25.9003H9.231C9.02478 25.9002 8.61599 25.4548 8.63335 25.2411C8.95222 21.3172 12.1372 19.3222 16.0191 19.3221ZM24.5555 24.1202C24.2433 22.7057 25.2715 21.0906 26.4742 21.8979C27.5561 22.6241 28.2713 23.7833 28.3648 25.4061C28.3717 25.5267 28.3646 25.8993 27.9185 25.8993H26.495C25.5304 25.8993 24.7633 25.0621 24.5555 24.1202Z",
    fill: "#4880FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticIconActionItems);
export default __webpack_public_path__ + "static/media/statistic_icon_action_items.73c59f84445f76cab2771cdb4112eaa5.svg";
export { ForwardRef as ReactComponent };